// tela-aplicativo-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Para abrir, seu perfil precisa da permissão de Configurações.": "Para abrirla, su perfil necesita el permiso de Configuración.",
};

export default catalogo;
